import { Upload, ScanLine, Wand2, FileDown } from "lucide-react";

const STEPS = [
  {
    icon: Upload,
    label: "Upload",
    text: "Drop a PDF, DOCX, or TXT. Single file or bulk batch.",
  },
  {
    icon: ScanLine,
    label: "Scrub",
    text: "Emails, phones, addresses, and socials are removed automatically.",
  },
  {
    icon: Wand2,
    label: "AI Parse",
    text: "Claude Sonnet 4.5 structures sections and writes role summaries.",
  },
  {
    icon: FileDown,
    label: "Brand & Export",
    text: "Render to PDF or DOCX with your logo, template, and footer.",
  },
];

export default function ProcessSteps() {
  return (
    <section className="my-16" id="process">
      <div className="mb-8">
        <span className="overline">03 · workflow</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-[var(--text-primary)] mt-3">
          From raw resume to focused dossier
          <br />
          in <span className="gradient-text">under 30 seconds.</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 relative">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.label}
              className="swiss-card lift-on-hover p-6 relative group"
              data-testid={`process-step-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-md bg-gradient-to-br from-[var(--brand-primary)] to-[var(--brand-accent)] text-white flex items-center justify-center shadow-md group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <span className="font-mono text-xs font-medium text-[var(--text-muted)]">
                  {String(i + 1).padStart(2, "0")} / 04
                </span>
              </div>
              <h3 className="font-heading font-semibold text-base text-[var(--text-primary)] mb-1.5">
                {s.label}
              </h3>
              <p className="text-sm leading-relaxed text-[var(--text-secondary)]">
                {s.text}
              </p>
              {i < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 z-10">
                  <div className="w-6 h-6 rounded-full bg-white border border-[var(--border-default)] shadow-sm flex items-center justify-center">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      aria-hidden="true"
                    >
                      <path
                        d="M1 5h7M5 1l4 4-4 4"
                        stroke="#1E3A8A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
